import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { fetchData, parsePaginatedList, formatNumber, getTranslatedValue, toasterrormsg, toastsuccessmsg } from '../../../../reusable'
import { PageTitle } from '../../../../_metronic/layout/core'
import { KTIcon } from '../../../../_metronic/helpers'
import { ToastContainer } from 'react-toastify'
import DataTable from '../../../components/AppDataTable'
import Loader from '../../component/Loader'
import clsx from 'clsx'
import moment from 'moment'
import Swal from 'sweetalert2'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { useLang } from '../../../../_metronic/i18n/Metronici18n'

const ViewTourPackageBooking: FC = () => {

  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId');
  useEffect(() => {
    if (categoryId != '5') {
      navigate('../dashboard/');
    }
  }, [categoryId])

  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;

  } else {
    console.log("No vendor data found");
  }
  const [offset, setOffset] = useState(0)
  const [limit, setLimit] = useState(10)
  const [totalRecords, setTotalRecords] = useState(0)
  const [tourPackageList, setTourPackageList] = useState([])
  const [statusTab, setStatusTab] = useState("");
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false)
  const [focus, setFocus] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)
  const latestRequestRef = useRef(0)

  //  booking list api call (server side pagination & search)
  const bookingListApiCall = async () => {
    const requestId = ++latestRequestRef.current
    setIsLoading(true)
    var param: any = {
      vendorId: String(vendorId),
      categoryId: "5",
      status: statusTab,
      term: debouncedSearchTerm.trim(),
      limit: limit,
      offset: offset
    }
    try {
      var res = await fetchData('public/bookingList', param)
      // ignore responses of outdated requests (fast typing / paging)
      if (requestId !== latestRequestRef.current) return

      if (res.status == '200') {
        const { list, total } = parsePaginatedList(res)
        // current page became empty (e.g. last booking of the page approved) -> go to previous page
        if (list.length == 0 && offset > 0) {
          setOffset(Math.max(0, offset - limit))
          return
        }
        setTourPackageList(list as any)
        setTotalRecords(total)
      } else {
        setTourPackageList([])
        setTotalRecords(0)
        toasterrormsg(res.message)
      }
    } catch (error) {
      if (requestId === latestRequestRef.current) toasterrormsg(t('Something went wrong'))
    } finally {
      if (requestId === latestRequestRef.current) setIsLoading(false)
    }
  }

  // go back to the first page whenever the filters change
  const resetToFirstPage = () => {
    setOffset(0)
    setResetPaginationToggle((prev) => !prev)
  }

  // reload current page (setter is stable, so it is safe inside memoized columns)
  const refreshList = () => setRefreshKey((prev) => prev + 1)

  const changeStatusTab = (status: string) => {
    if (status === statusTab) return
    setStatusTab(status)
    resetToFirstPage()
  }

  const handlePageChange = (newPage: number) => {
    setOffset((newPage - 1) * limit)
  }

  const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
    setLimit(newRowsPerPage)
    setOffset((currentPage - 1) * newRowsPerPage)
  }

  // debounce search so the api is not called on every keystroke
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchTerm.trim() !== debouncedSearchTerm) {
        setDebouncedSearchTerm(searchTerm.trim())
        resetToFirstPage()
      }
    }, 500)
    return () => clearTimeout(timer)
  }, [searchTerm])

  //   change status for approve api call
  const approveBookingApiCall = (id: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t(`You Want To Approve Booking`),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          vendorId:vendorId,
          categoryId:categoryId,
          bookingId: id,
          status:1
        }
        var res = await fetchData('public/bookingStatusChange', param)
        
        if (res.status == '200') {
          toastsuccessmsg(t("Booking Approved."))
          refreshList()
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }
  //   change status for reject api call
  const rejectBookingApiCall = (id: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t(`You Want To Reject Booking`),
      icon: 'warning',
      showCancelButton: true,
      input:'text',
      inputPlaceholder: t("Enter Reject Reason"),
      inputValidator: (value) => {
          if (!value) {
              return t('You need to enter a reject reason!');
          }
      },
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          vendorId:vendorId,
          categoryId:categoryId,
          bookingId: id,
          status:2,
          reason: result.value
        }
        var res = await fetchData('public/bookingStatusChange', param)
        if (res.status == '200') {
          toastsuccessmsg(t("Booking Rejected."))
          refreshList()
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }

  // search Data
  const searchData = (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {

      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }
  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('#')}</label>),
        selector: (row: any, index: any) => offset + index + 1, // continue numbering across pages
        width: '50px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Action')}</label>),
        cell: (row: any) => (
          <>
            {row.status == 0 && (
                <button
                  onClick={() => {approveBookingApiCall(row.bookingId)}}
                  className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                  data-kt-menu-flip='top-end'
                  data-toggle="tooltip"
                  title={t("Approve")}
                >
                  <KTIcon iconName='check-square' className='fs-2x text-primary' />
                </button>
              )
            }
            { row.status == 0 && (
              <button
                onClick={() => {rejectBookingApiCall(row.bookingId)}}
                className='btn btn-sm btn-icon btn-color-danger btn-active-light-danger'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
                data-toggle="tooltip"
                title={t("Reject")}
              >
                <KTIcon iconName='cross-square' className='fs-2x text-danger' />
              </button>
            )}
          </>
        ),
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Booking Status')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            {row.status == 0 ? (
                <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Pending')}</span>
              ) : row.status == 1 ? (
                <span className='btn btn-success mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Approved')}</span>
              ) : row.status == 2 ? (
                <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Rejected')}</span>
              ) : row.status == 3 ? (
                <>
                  <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Cancelled')}</span> <br />
                  <div className='text-center mt-2'>
                    {' '}
                    <span className='fw-bold fs-6'>
                      ({row.cancellationCharge ? row.cancellationCharge + `% ${t('Charges')}` : `0% ${t('Charges')}`})
                    </span>
                  </div>
                </>
              ) : (
                <span className='btn btn-success mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Completed')}</span>
              )}
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Booking ID')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
                <label className='fs-6 fw-bold cursor-pointer'>
                <Link
                  to='../viewtourbookingdetails/'
                  state={{ bookingId: row.bookingId }}
                  className='text-primary text-decoration-underline fw-bold text-hover-primary mx-2'
                >
                  {row.bookingCode ? '#'+row.bookingCode : ''}
                </Link>
                </label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '250px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Guest Name')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-6'>
              {row.guestName ? row.guestName : ''}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        width: '250px',
        selector: (row: any) =>
          row.guestName ? row.guestName : '',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Tour Date')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.tourDate ? moment(row.tourDate).format('DD.MM.YYYY')  : '---'}</div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Tour Duration')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.tourDuration ? row.tourDuration : ''}</label>
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        width: '250px',
        selector: (row: any) =>
          row.tourDuration ? row.tourDuration : '',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Total Tour Tickets')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.totalTourTickets ? row.totalTourTickets : ''}</label>
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        width: '250px',
        selector: (row: any) =>
          row.totalTourTickets ? row.totalTourTickets : '',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Tour Agency Name')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{getTranslatedValue(lang, row, '_actionName') || '-'}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => getTranslatedValue(lang, row, '_actionName'),
        filter: true,
        width: '222px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Tour Name')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{getTranslatedValue(lang, row, 'Name')}</label>
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        width: '250px',
        selector: (row: any) => getTranslatedValue(lang, row, 'Name'),
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Booked On')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.created ? moment(row.created).format('DD.MM.YYYY')  : '---'}</div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Original Amount')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.originalAmount >= 0 ? formatNumber(row.originalAmount)+' UZS' : '---'}</label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Final Amount')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.totalAmount >= 0 ? formatNumber(row.totalAmount)+' UZS' : ''}</label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Insayr Service Fee')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.InsayrServiceFee >= 0 ? formatNumber(row.InsayrServiceFee)+' UZS' : '---'}</label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
    ],
    [t, offset]
  )
  useEffect(() => {
    bookingListApiCall()
  }, [statusTab, debouncedSearchTerm, limit, offset, refreshKey])

  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Booking List')}</PageTitle>
      {
        <div className="card card-flush py-4">
          <div className="card-body pt-0">
            <div className='card card-custom'>
              <div className='card-header card-header-stretch overflow-auto'>
                <ul
                  className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                  role='tablist'
                >
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '' })}
                      onClick={() => changeStatusTab('')}
                      role='tab'
                    >
                      {t('All')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '0' })}
                      onClick={() => changeStatusTab('0')}
                      role='tab'
                    >
                      {t('Pending')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '1' })}
                      onClick={() => changeStatusTab('1')}
                      role='tab'
                    >
                      {t('Approved')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '2' })}
                      onClick={() => changeStatusTab('2')}
                      role='tab'
                    >
                      {t('Rejected')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '3' })}
                      onClick={() => changeStatusTab('3')}
                      role='tab'
                    >
                      {t('Cancelled')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '4' })}
                      onClick={() => changeStatusTab('4')}
                      role='tab'
                    >
                      {t('Completed')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <DataTable
              columns={column}
              data={tourPackageList}
              pagination
              paginationServer={true}
              paginationTotalRows={totalRecords}
              paginationPerPage={limit}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              paginationResetDefaultPage={resetPaginationToggle}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              subHeader={true}
              subHeaderComponent={
                <CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />
              }
            />
          </div>
        </div>
      }
    </>
  )
}

export { ViewTourPackageBooking }
